import { Trans, useTranslation }                     from 'react-i18next'
import {
  Container, Divider,
  Grid, List, Typography
}                                                    from '@mui/material'
import { useApi }                                    from '../utils/api'
import React, { useEffect, useState }                from 'react'
import { fDateTime, fOperator }                      from '../utils/textutils'
import Page                                          from '../ui/components/Page'
import { BaseBreadcrumbs }                           from '../ui/components/BaseBreadcrumbs'
import { useParams }                                 from 'react-router-dom'
import BaseTable                                     from '../ui/components/base-table'
import { ClickableDataRow, DataRow }                 from '../components/DataRow'
import ContentWidget                                 from '../components/ContentWidget'
import Consts                                        from '../Consts'

export default function MessagePage () {

  const { messageId } = useParams()
  const { t } = useTranslation()
  const api = useApi()
  const [message, setMessage] = useState(null)

  useEffect(() => {
    api.message.detail(messageId).then(msg => {
      setMessage(msg)
    }).catch(e => {})
  }, [messageId])

  const logColumns = [
    { field: 'created', headerName: t('Created'), width: 140, sortable: false, filterable: false, renderCell: (cell) => fDateTime(cell.row.created) },
    { field: 'action', headerName: t('Log action'), flex: 1, sortable: false, filterable: false },
    { field: 'message', headerName: t('Log message'), flex: 2, sortable: false, filterable: false },
  ];

  return (<Page title={`#${messageId} ${t('Message')}`}>
    <Container maxWidth={'xl'}>
      <BaseBreadcrumbs key={'breadcrumb-messages'}
                       title={`${t('Message')} #${messageId}`}
                       items={[
                         { href: '/messages', title: t('Messages') }
                       ]}/>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <ContentWidget id={message?.id} title={t('Content')} content={message?.content ?? ''} message={message} transaction={message?.transaction} />
        </Grid>
        <Grid item xs={12} md={6}>
          <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
            <DataRow title={t('SMS Type')} content={t(`smstype-${message?.type}`)} icon={'material-symbols:info'}/>
            <Divider component={'li'} />
            <DataRow title={t('Tel. From')} content={message?.telFrom} icon={'material-symbols:call-made'}/>
            <Divider component={'li'} />
            <DataRow title={t('Tel. To')} content={message?.telTo} icon={'material-symbols:call-received'}/>
            <Divider component={'li'} />
            <DataRow title={t('Operator')} content={fOperator(message?.operatorShort)} icon={'material-symbols:deskphone'} />
            {message?.parentId && <>
              <Divider component={'li'} />
              <ClickableDataRow
                icon={'material-symbols:sms'}
                title={t('Incoming SMS')}
                content={<Trans i18nKey={'ShowUserSms'} values={{ id: message.parentId }} />}
                href={`/messages/${message.parentId}`}
              />
            </>}
          </List>
        </Grid>
        <Grid item xs={12} md={6}>
          <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
            <DataRow title={t('Created')} content={message?.created ? fDateTime(message.created) : t('Not set')} />
            <Divider component={'li'} />
            <DataRow title={t('Received')} content={message?.received ? fDateTime(message.received) : t('Not set')} />
            <Divider component={'li'} />
            <DataRow title={t('Sent')} content={message?.sent ? fDateTime(message.sent) : t('Not set')} />
          </List>
        </Grid>
      </Grid>
      <Grid item xs={12} mt={2}>
        <Typography variant={'h4'}>{t('Logs')}</Typography>
        <BaseTable
          columns={logColumns}
          loadCallback={async (query, page, pageSize) => {
            try {
              return await api.log.messageList(messageId)
            } catch (e) {
              console.log('Failed to load message logs', e)
              return {
                data: [],
                totalCount: 0,
              }
            }
          }}
        />
      </Grid>
    </Container>
  </Page>)
}
